import { Button } from '@warp-ds/react';

import type { ReactNode } from 'react';

import styles from '../FrontPageModal.module.css';

interface FrontPageModalFooterProps {
    onClose: () => void;
    children?: ReactNode;
}

export const FrontPageModalFooter = ({ onClose }: FrontPageModalFooterProps) => (
    <footer className={styles.modal__footer}>
        {/* @ts-ignore: TODO typedefs from @fabric-ds is confusing the build somehow.. remove when fabric is gone. */}
        <Button primary fullWidth type="button" onClick={onClose}>
            Bruk
        </Button>
    </footer>
);
